var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-content"},[_c('TaskList',{ref:"taskList"}),_c('TaskNew',{on:{"add-task":function($event){return _vm.scrollToBottom()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }